import * as utils from '../utils';
export default function scrollPosition(elem, config) {
	var config = config || {};
	var wheight = window.innerHeight;
	var offset = config.offset || 2;
	var callback = config.callback || function () {};

	function scrollFired() {
		wheight = window.innerHeight;
		getScrollPosition();
	}

	window.addEventListener('scroll', utils.throttle(scrollFired, 150));
	window.addEventListener('resize', utils.throttle(scrollFired, 400));

	function getScrollPosition(){
		for (var i = 0; i < elem.length; i++) {
			var elemTop = elem[i].getBoundingClientRect().top;
			if (elemTop > 0 && elemTop < wheight / 2) {
				callback({index: i});
				return; // found first then stop
			}
		}
	}
}


//////////////////
// WEBPACK FOOTER
// ./src/js/components/scrollPosition.js
// module id = 54
// module chunks = 0